import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useOrganization } from "../../../context/OrganizationContext";
import { AlertBox } from "../../UI/DesignStandards";
import { getOrganizationPlan } from "../../../utility/organizationPlan";
import {
  planCapDisplayLimit,
  planStatusCopy,
} from "../../../utility/planStatus";
import { tournamentCapUsageCopy } from "../../../utility/tournamentCaps";

const OrganizationPlanCard = () => {
  const { currentOrganization } = useOrganization();
  const organizationId = currentOrganization?.id;
  const [copy, setCopy] = useState(null);
  const [capCopy, setCapCopy] = useState(null);

  useEffect(() => {
    if (!organizationId) return undefined;
    let cancelled = false;
    getOrganizationPlan(organizationId)
      .then((plan) => {
        if (!cancelled) {
          setCopy(planStatusCopy(plan));
          const displayLimit = planCapDisplayLimit(plan);
          setCapCopy(
            displayLimit === undefined
              ? null
              : tournamentCapUsageCopy({
                  tournamentCount: plan?.tournamentCount,
                  tournamentLimit: displayLimit,
                })
          );
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCopy(null);
          setCapCopy(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  return (
    <section className="card-board p-6 space-y-2" aria-labelledby="profile-plan-heading">
      <h2
        id="profile-plan-heading"
        className="font-display font-bold text-lg text-brand-charcoal"
      >
        Plan
      </h2>
      {copy ? (
        <>
          <p className="text-sm font-medium text-brand-charcoal">{copy.label}</p>
          <p className="text-sm text-brand-muted">{copy.detail}</p>
          {capCopy?.usage ? (
            <p className="text-sm text-brand-muted">{capCopy.usage}</p>
          ) : null}
          {copy.paymentNote ? (
            <AlertBox
              type="error"
              title="Payment failed"
              message={copy.paymentNote}
            />
          ) : null}
          {copy.disputeNote ? (
            <AlertBox type="error" title="Dispute" message={copy.disputeNote} />
          ) : null}
          {capCopy?.atCap ? (
            <AlertBox
              type="error"
              title="Tournament limit"
              message={capCopy.message}
            />
          ) : null}
        </>
      ) : null}
      <Link to="/organization/plan" className="inline-block text-sm underline text-brand-gold-ink">
        Open Plan
      </Link>
    </section>
  );
};

export default OrganizationPlanCard;
